<template>
<div class="chapter">
<div class="inner_page">
<p class="part-title">I. Gospels and Related Traditions of New Testament Figures</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 009_Part01.vue?7d90e622